import { TRootState } from 'redux/reducers/rootReducer';
import RequestStatus from 'types/general/requests/RequestStatus';
import { useThunkDispatch } from './useThunkDispatch';
import EStatusAPIKeys from 'types/backend_models/lookup_status/EStatusAPIKeys';
import { fetchStatus } from 'redux/actions/dataActions/lookup_status/statusDataActions';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

function useStatusDynamic(statusKey: EStatusAPIKeys)
{
	const thunkDispatch = useThunkDispatch();

	const statusState = useSelector((state: TRootState) => state.data.statusses[statusKey]);

	useEffect(() =>
	{
		if (statusState.requestStatus === RequestStatus.idle) {
			thunkDispatch(fetchStatus(statusKey));
		}
	}, [thunkDispatch, statusKey, statusState]);

	return statusState;
}

export default useStatusDynamic;